import { RotateCcw } from 'lucide-react';
import { AGENDA_COLOR_PRESETS, normalizeAgendaColor } from '../../utils/agendaColor';

interface AgendaColorFieldProps {
  value?: string | null;
  onChange: (value: string) => void;
}

const AgendaColorField = ({ value, onChange }: AgendaColorFieldProps) => {
  const normalizedColor = normalizeAgendaColor(value) || '';
  const pickerColor = normalizedColor || AGENDA_COLOR_PRESETS[0];

  return (
    <div className="space-y-3">
      <div className="flex items-start justify-between gap-3">
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Cor da Agenda
          </label>
          <p className="mt-1 text-xs text-gray-500">
            Usada na legenda e nos cards dos agendamentos desse profissional.
          </p>
        </div>
        <button
          type="button"
          onClick={() => onChange('')}
          className="inline-flex items-center rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-700 transition hover:bg-gray-50"
        >
          <RotateCcw className="mr-2 h-4 w-4" />
          Automática
        </button>
      </div>

      <div className="flex flex-wrap gap-2">
        {AGENDA_COLOR_PRESETS.map((presetColor) => {
          const isSelected = presetColor === normalizedColor;

          return (
            <button
              key={presetColor}
              type="button"
              aria-label={`Selecionar cor ${presetColor}`}
              aria-pressed={isSelected}
              onClick={() => onChange(presetColor)}
              className={`flex h-10 w-10 items-center justify-center rounded-full border transition ${
                isSelected
                  ? 'border-slate-900 ring-2 ring-slate-300'
                  : 'border-gray-200 hover:border-gray-400'
              }`}
              title={presetColor}
            >
              <span
                className="h-6 w-6 rounded-full border border-white/80 shadow-sm"
                style={{ backgroundColor: presetColor }}
              />
            </button>
          );
        })}
      </div>

      <div className="flex items-center gap-3">
        <label className="flex items-center gap-3 rounded-md border border-gray-300 px-3 py-2">
          <input
            type="color"
            value={pickerColor}
            onChange={(event) => onChange(event.target.value)}
            className="h-8 w-10 cursor-pointer rounded border-0 bg-transparent p-0"
          />
          <span className="text-sm text-gray-700">Escolher outra cor</span>
        </label>

        <div className="inline-flex items-center gap-2 rounded-md border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-700">
          <span
            className="h-4 w-4 rounded-full border border-white shadow-sm"
            style={{ backgroundColor: normalizedColor || '#CBD5E1' }}
          />
          {normalizedColor || 'Automática'}
        </div>
      </div>
    </div>
  );
};

export default AgendaColorField;
